import {cx} from "@emotion/css";

import {ReactComponent as SvgFilterIcon} from "~/assets/svg/filter.svg";
import {designColors} from "~/ui";

import {simpleIconStyles} from "../styles";
import {commonStyles} from "../../_common/styles";
import {IIconBase} from "../../_common/types";

export const BmFilterIcon: React.FC<IIconBase> = ({id, size = "sm", color = designColors.black, className}) => {
  return <SvgFilterIcon id={id} className={cx(simpleIconStyles(size), commonStyles.color(color), className)} />;
};
